(function () {
  // Event delegation on document (not per-element binding) so this keeps
  // working after collection grids are re-rendered via AJAX (filtering,
  // infinite scroll, "load more"), without needing to re-bind anything.

  // Deferred loading of the hover-slider photos.
  // The slider is only faded out (opacity:0) on desktop, not hidden, so if
  // its slides carried the "lazyload" class the lazy-loader would treat them
  // as visible and download EVERY gallery photo of EVERY product card as the
  // page scrolls, even though most are never hovered. Instead the slides are
  // rendered with "craft-slide-deferred" (ignored by the lazy-loader) and are
  // only switched to "lazyload" the first time the shopper hovers that card.
  // The main and hover images keep loading exactly as before, and the
  // slide shown first (the second photo) is the same image as the card's
  // hover image, so it's already cached and appears instantly.
  function loadSlides(wrap) {
    if (!wrap || wrap.getAttribute('data-slides-loaded')) return;
    wrap.setAttribute('data-slides-loaded', '1');
    var slides = wrap.querySelectorAll('.craft-slide-deferred');
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      s.classList.remove('craft-slide-deferred');
      s.classList.add('lazyload');
      if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.unveil) {
        window.lazySizes.loader.unveil(s);
      }
    }
  }
  document.addEventListener('mouseover', function (e) {
    var wrap = e.target.closest && e.target.closest('.grid_img_wr');
    if (wrap) loadSlides(wrap);
  });
  document.addEventListener('focusin', function (e) {
    var wrap = e.target.closest && e.target.closest('.grid_img_wr');
    if (wrap) loadSlides(wrap);
  });

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('.craft-grid-arrow');
    if (!arrow) return;

    // Stop this click from ever reaching the <a class="grid_lnk"> product
    // link the slider sits on top of -- otherwise clicking an arrow would
    // navigate to the product page instead of just changing the slide.
    e.preventDefault();
    e.stopPropagation();

    var slider = arrow.closest('.craft-grid-slider');
    if (!slider) return;

    loadSlides(slider.closest('.grid_img_wr'));

    var slides = slider.querySelectorAll('.craft-grid-slide');
    var dots = slider.querySelectorAll('.craft-grid-dot');
    if (!slides.length) return;

    var currentIndex = 0;
    slides.forEach(function (slide, i) {
      if (slide.classList.contains('is-active')) currentIndex = i;
    });

    var nextIndex;
    if (arrow.classList.contains('next')) {
      nextIndex = (currentIndex + 1) % slides.length;
    } else {
      nextIndex = (currentIndex - 1 + slides.length) % slides.length;
    }

    slides[currentIndex].classList.remove('is-active');
    slides[nextIndex].classList.add('is-active');

    if (dots.length) {
      dots[currentIndex].classList.remove('is-active');
      dots[nextIndex].classList.add('is-active');
    }

    // The slider box is a fixed 1:1.8 shape (set in CSS) for every card,
    // regardless of which photo is active, so there's no per-slide ratio
    // to apply here anymore -- background-size:cover on each slide fills
    // that fixed box on its own.
  });
})();
